export const payment_modes = [
  { code: 'postpaid', label: 'payment_modes.postpaid' },
  { code: 'prepaid', label: 'payment_modes.prepaid'},
];
